import { useState } from 'react';
import { Box, Divider, Flex, Icon, Select, Text } from '@chakra-ui/react';
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from 'react-icons/fi';

const porPage = [10, 15, 20, 25, 30];

type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type VendaData = {
	agendamento: boolean;
	campanha: string;
	cupom: { id_desconto: string; type_desc: string; valor: string };
	distance: number;
	duration: number;
	endereco_entrega: EnderecoData;
	formatted_address: string;
	hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	};
	id_order: number;
	items: ItemData[];
	merchant_id: number;
	mesa: boolean;
	mesa_number: string;
	mesa_token: string;
	order_data: string;
	order_status: string;
	pagamentos: PagamentoData[];
	prev_entrega: string;
	retirar: boolean;
	subTotal: number;
	taxa_entrega: number;
	taxa_service: number;
	tempo_preparo: number;
	tempo_preparo_str: string;
	total: number;
	totalFormatted: string;
	total_merchant: number;
}
type EnderecoData = {
	bai: string;
	cep: string;
	cid: string;
	cidcod: string;
	comp: string;
	distace: {
		distance: { value: number };
		duration: { value: number };
	};
	endereco: string;
	formatted_address: string;
	id: string;
	location: { lat: number; lng: number };
	num: string;
	ponto_ref: string;
	uf: string;
}
type PagamentoData = {
	band_pay: string;
	chave_pay: string;
	currency_pay: string;
	id_pay: number;
	method_pay: string;
	name_pay: string;
	tipchave_pay: string;
	trocoFormatted: string;
	troco_para: number;
	type_pay: string;
	url_pay: string;
}
type ItemData = {
	cod_barras: string;
	complementos: ComplementoData[];
	descricao: string;
	id: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	totalFormatted: string;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
}
type ComplementoData = {
	codigo: string;
	descricao: string;
	grupo: string;
	nome: string;
	priceFormatted: string;
	qtd: number;
	qtd_gratis: number;
	qtd_maxima: number;
	valor: number;
}
interface DataTablePaginateParams {
  vendas_length: number;
  pesq_length: number;
	pesqVendas: VendaData[];
  controls: ControlsData;
  setControls: (control: ControlsData) => void;
  handleUpdateList: (
    page: number,
    perPage: number,
		vendas: VendaData[],
  ) => void;
}

const DataTablePaginate: React.FC<DataTablePaginateParams> = ({
	vendas_length,
	pesq_length,
	pesqVendas,
  handleUpdateList,
}) => {
  const [controls, setControls] = useState({
    page: 1,
    perPage: 10,
		totalPage: Math.ceil(vendas_length / 10),
  });

  function next() {
    let auxPage = controls.page + 1;

    if (auxPage > controls.totalPage) {
      auxPage -= 1;
    }
    setControls({ ...controls, page: auxPage });

		handleUpdateList(auxPage, controls.perPage, pesqVendas);
  }

  function prev() {
    let auxPage = controls.page - 1;

    if (auxPage < 1) {
      auxPage += 1;
    }
    setControls({ ...controls, page: auxPage });

		handleUpdateList(auxPage, controls.perPage, pesqVendas);
  }

  function goTo(page: number) {
    if (page < 1) {
      page = 1;
    }

    setControls({ ...controls, page });

    if (controls.page > controls.totalPage) {
      setControls({ ...controls, page: controls.totalPage });
    }

		handleUpdateList(page, controls.perPage, pesqVendas);
  }

  async function handleControlsPerPage(event: string) {
    const perPage = Number(event);

    setControls({
      page: 1,
      perPage,
      totalPage: Math.ceil(pesq_length / perPage),
    });

		handleUpdateList(1, perPage, pesqVendas);
  }

  return (
    <Flex w="100%" p="2" flexDir="column">
      <Divider orientation="horizontal" size="sm" />

      <Flex
        flexDir={['column', 'row']}
        justify="center"
        align="center"
        w="100%"
        p="2"
      >
        {/* POR PÁGINA */}
        <Flex as="form" justify="end" align="center">
          <Text fontSize="13" fontWeight="500" color="gray.400" mr="1">
            items por pag.
          </Text>
          <Box>
            <Select
              name="per_page"
              size="xs"
              fontWeight="500"
              onChange={e => handleControlsPerPage(e.target.value)}
            >
              {porPage.map(pPage => {
                return (
                  <option key={pPage} value={pPage}>
                    {pPage}
                  </option>
                );
              })}
            </Select>
          </Box>
        </Flex>

        {/* INDICES */}
        <Flex align="center" px="2">
          <Text fontSize="13" fontWeight="500" color="gray.400">
            {controls.page * controls.perPage > pesq_length
              ? pesq_length
              : `${controls.page * controls.perPage - controls.perPage + 1}
								- ${controls.page * controls.perPage} de ${pesq_length}`}
          </Text>
        </Flex>

        {/* SETAS */}
        <Flex align="center" px="2">
          <Text as="button" px={['2', '0']} onClick={() => goTo(1)}>
            <Icon as={FiChevronsLeft} fontSize="32" color="gray.400" />
          </Text>

          <Text as="button" px={['2', '0']} onClick={prev}>
            <Icon as={FiChevronLeft} fontSize="30" color="gray.400" />
          </Text>

          <Text as="button" px={['2', '0']} onClick={next}>
            <Icon as={FiChevronRight} fontSize="30" color="gray.400" />
          </Text>

          <Text
            as="button"
            px={['2', '0']}
            onClick={() => goTo(controls.totalPage)}
          >
            <Icon as={FiChevronsRight} fontSize="32" color="gray.400" />
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DataTablePaginate;
